import React, { useContext, useEffect, useState } from 'react'
import { AiOutlineCloudUpload } from 'react-icons/ai'
import { BsSearch } from 'react-icons/bs'
import { MediaFromResponse } from '../../models/from-api-response/media'
import { getMedias } from '../../services/medias'
import DefaultButton from '../DefaultButton'
import SambaVideosContentCard from '../SambaVideosContentCard'
import UploadSamba from './components/UploadSamba'
import {
	ContentList,
	ContentListContainer,
	ContentListFilter,
	ContentListFilters,
	SelectSambaVideosContentContainer,
} from './style'
import AppContext from 'contexts/AppContext'

interface SelectSambaVideosContentProps {
	onSelectContent: (content: MediaFromResponse) => void
}

const SelectSambaVideosContent: React.FC<SelectSambaVideosContentProps> = ({ onSelectContent }) => {
	const [reference, setReference] = useState('')
	const numberOfMediasPerPage = 10
	const page = 1

	const [loadingMoreMedias, setLoadingMoreMedias] = useState(false)
	const [shouldShowLoadMoreMedias, setShouldShowLoadMoreMedias] = useState(true)
	const [searchText, setSearchText] = useState('')
	const [isUploading, setIsUploading] = useState(false)
	const [completeUpload, setCompleteUpload] = useState(false)
	const [contents, setContents] = useState([] as MediaFromResponse[])
	const [shouldShowLoading, setShouldShowLoading] = useState(true)
	const [numberOfContentsToBeShown, setNumberOfContentsToBeShown] = useState(page)
	const { environmentVariables } = useContext(AppContext)

	const getSambaVideosContents = async (event?: React.FormEvent) => {
		if (event && event.preventDefault) {
			event.preventDefault()
		}

		setContents([])
		const localItems = await getMedias({
			title: searchText,
			page: 1,
			limit: numberOfMediasPerPage,
			types: 'video',
			published: true,
			sort: 'created_at,desc',
		})
		const localContents = localItems.items
		if (localContents && localContents.length) {
			setContents(localContents)
			setShouldShowLoading(true)
			setNumberOfContentsToBeShown(2)
		} else {
			setShouldShowLoading(false)
		}
	}

	const loadMoreMedias = async () => {
		setLoadingMoreMedias(true)

		const localItems = await getMedias({
			title: searchText,
			page: numberOfContentsToBeShown,
			limit: numberOfMediasPerPage,
			types: 'video',
			published: true,
			sort: 'created_at,desc',
		})
		const localContents = localItems.items;

		if (localContents && localContents.length) {
			const localJoinedContents = [...contents, ...localContents]

			if (localJoinedContents.length % numberOfMediasPerPage > 0) {
				setShouldShowLoadMoreMedias(false)
			}

			setContents(localJoinedContents)
			setShouldShowLoading(true)
		} else {
			setShouldShowLoading(false)
			setShouldShowLoadMoreMedias(false)
		}

		setNumberOfContentsToBeShown(numberOfContentsToBeShown + 1)
		setLoadingMoreMedias(false)
	}

	useEffect(
		() => {
			getSambaVideosContents()
		},
		// eslint-disable-next-line
		[completeUpload]
	)

	return (
		<SelectSambaVideosContentContainer>
			<UploadSamba setReference={setReference}>
				<AiOutlineCloudUpload size={128} />
				{!isUploading && <p>Fazer Upload de Conteúdo</p>}
				{isUploading && <p>Aguarde o Upload do Conteúdo</p>}
			</UploadSamba>

			<ContentListContainer>
				<ContentListFilters onSubmit={getSambaVideosContents}>
					<ContentListFilter
						value={searchText}
						onChange={(e) => setSearchText(e.target.value)}
						type="search"
					/>
					<DefaultButton type="submit">
						<BsSearch />
					</DefaultButton>
				</ContentListFilters>

				<ContentList>
					{contents && contents.length ? (
						<>
							{contents.map((content) => (
								<SambaVideosContentCard onClick={onSelectContent} key={content.id} content={content} />
							))}
							{shouldShowLoadMoreMedias ? (
								<div className="center">
									{loadingMoreMedias ? (
										<div className="spinner small"></div>
									) : (
										<DefaultButton onClick={loadMoreMedias}>Carregar Mais</DefaultButton>
									)}
								</div>
							) : (
								<></>
							)}
						</>
					) : shouldShowLoading ? (
						<div className="spinner"></div>
					) : (
						<>Nenhum conteúdo encontrado.</>
					)}
				</ContentList>
			</ContentListContainer>
		</SelectSambaVideosContentContainer>
	)
}

export default SelectSambaVideosContent
